import { translate, translateObject } from '@jsverse/transloco';

import { SemantriaConfiguration } from 'app/providers/semantria-api/configuration.service';

export class ConfigurationUtils {
  public static hasEieTag(configuration: SemantriaConfiguration) {
    return (
      configuration?.deep_models?.length > 0 ||
      configuration?.settings?.includes('SENTIMENT_CLAUSE_MODELS')
    );
  }

  public static hasTags(configuration: SemantriaConfiguration) {
    return (
      this.hasEieTag(configuration) ||
      configuration.tags?.length > 0 ||
      configuration.config_routes?.length > 0
    );
  }

  private static getDeepModelTextFormatted(deepModel: string) {
    const translationObj = translateObject('configurations.analytic-items');
    return translationObj[deepModel.toLocaleLowerCase()];
  }

  public static getEieTagText(configuration: SemantriaConfiguration) {
    let result = '';

    if (configuration.deep_models?.length > 0) {
      result += this.getDeepModelTextFormatted(configuration.deep_models[0]);
    }

    if (configuration.settings?.includes('SENTIMENT_CLAUSE_MODELS')) {
      if (result) {
        result += '/\n';
      }
      result += translate('configurations.analytic-items.sentiment');
    }

    return result;
  }

  public static getEieTagTooltipText(configuration: SemantriaConfiguration) {
    let result = '';

    if (configuration.deep_models?.length > 0) {
      result += translate('configurations.analytic-items.eie-tooltip', {
        model: this.getDeepModelTextFormatted(configuration.deep_models[0]),
      });
    }

    if (configuration.settings?.includes('SENTIMENT_CLAUSE_MODELS')) {
      if (result) {
        result += '\n';
      }
      result += translate('configurations.analytic-items.eie-tooltip-sentiment');
    }

    return result;
  }
}
